import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';
import { actionLog } from 'services/actionlog.service';

import { ConfirmacaoDaAcao } from './moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  playerInfo: any;
  data?: any;
}

export default function ModalStopQuiz(props: Props) {
  const modalID = 'validation-stop-quiz';

  const { openModal, closeModal } = useModal();
  const { callback, id, playerInfo, data } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  async function send() {
    if (!playerInfo?._id) return;

    setLoading(true);

    await actionLog(playerInfo.chave, 'answer_quiz', {
      taskId: data._id,
      answered: false,
    });

    callback({ id: 'stop_quiz' });
    closeModal();
    setLoading(false);
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <ConfirmacaoDaAcao
      title="Matriz de orientação"
      onClose={() => (!loading ? closeModal() : null)}
      backDisabled={loading}
      onConfirm={() => {
        send();
      }}
    >
      <p className="m-0">
        Ao negar a possibilidade de apreciar a realização pela orientação da matriz, essa ação não poderá ser desfeita. Deseja
        confirmar essa ação?
      </p>
    </ConfirmacaoDaAcao>
  );
}
